import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var SortArrowUp = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M22.207 10.206a.997.997 0 01-1.414 0L17 6.413v21.586a1 1 0 11-2 0V6.413l-3.793 3.793a.999.999 0 11-1.414-1.414l5.499-5.5a1 1 0 011.416 0l5.499 5.5a.999.999 0 010 1.414" })), '0 0 32 32', 'SortArrowUp');
//# sourceMappingURL=SortArrowUp.js.map